import { normalizePartnerIdentifier } from "partners/partnerExperiences";

export type SelfCampaignQueryParams = {
  email?: string;
  businessName?: string;
  name?: string;
  phone?: string;
  id?: string;
  legacyLeadSubmissionId?: string;
  partner?: string;
};

const sanitizeTextParam = (value: string | null): string | undefined => {
  const trimmed = (value ?? "").trim();
  return trimmed.length > 0 ? trimmed : undefined;
};

export const decodeEmailFromQueryParam = (
  value: string | null,
): string | undefined => {
  const decoded = (value ?? "").replace(/ /g, "+").trim().toLowerCase();
  return decoded.length > 0 ? decoded : undefined;
};

export const decodePhoneFromQueryParam = (
  value: string | null,
): string | undefined => {
  const decoded = (value ?? "").replace(/ /g, "+").trim();
  return decoded.length > 0 ? decoded : undefined;
};

export const getSelfCampaignQueryParams = (
  search: string,
): SelfCampaignQueryParams => {
  const params = new URLSearchParams(search);
  const id = sanitizeTextParam(params.get("id"));
  const legacyLeadSubmissionId = sanitizeTextParam(
    params.get("leadSubmissionId"),
  );
  const normalizedPartner =
    normalizePartnerIdentifier(params.get("partner")) ||
    normalizePartnerIdentifier(params.get("campaign"));

  return {
    email: decodeEmailFromQueryParam(params.get("email")),
    businessName: sanitizeTextParam(params.get("businessName")),
    name: sanitizeTextParam(params.get("name")),
    phone: decodePhoneFromQueryParam(params.get("phone")),
    id: id || legacyLeadSubmissionId,
    legacyLeadSubmissionId,
    partner: normalizedPartner,
  };
};

export const buildSelfCampaignSearchWithId = (
  _search: string,
  id: string,
): string => {
  const params = new URLSearchParams();
  params.set("id", id);
  return `?${params.toString()}`;
};
